import { clsx } from 'clsx';
import React from 'react';
import styled from 'styled-components';
import Box from '../Box/Box.js';
import { get } from '../constants.js';
import sx from '../sx.js';
import classes from './Breadcrumbs.module.css.js';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SELECTED_CLASS = 'selected';
const CSS_MODULES_FLAG = 'primer_react_css_modules_ga';
const Wrapper = toggleStyledComponent(CSS_MODULES_FLAG, 'li', styled.li.withConfig({
  displayName: "Breadcrumbs__Wrapper",
  componentId: "sc-9m4wsf-0"
})(["display:inline-block;white-space:nowrap;list-style:none;&::after{font-size:", ";content:'';display:inline-block;height:0.8em;margin:0 0.5em;border-right:0.1em solid;border-color:", ";transform:rotate(15deg) translateY(0.0625em);}&:first-child{margin-left:0;}&:last-child{&::after{content:none;}}"], get('fontSizes.1'), get('colors.fg.muted')));
const BreadcrumbsBase = toggleStyledComponent(CSS_MODULES_FLAG, 'nav', styled.nav.withConfig({
  displayName: "Breadcrumbs__BreadcrumbsBase",
  componentId: "sc-9m4wsf-1"
})(["display:flex;justify-content:space-between;", ";"], sx));
const BreadcrumbsList = ({
  children
}) => {
  const enabled = useFeatureFlag(CSS_MODULES_FLAG);
  if (enabled) {
    return /*#__PURE__*/React.createElement("ol", {
      className: classes.BreadcrumbsList
    }, children);
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: "ol",
    my: 0,
    pl: 0
  }, children);
};
BreadcrumbsList.displayName = "BreadcrumbsList";
function Breadcrumbs({
  className,
  children,
  sx: sxProp
}) {
  const enabled = useFeatureFlag(CSS_MODULES_FLAG);
  const wrappedChildren = React.Children.map(children, child => /*#__PURE__*/React.createElement(Wrapper, {
    className: clsx({
      [classes.ItemWrapper]: enabled
    })
  }, child));
  return /*#__PURE__*/React.createElement(BreadcrumbsBase, {
    className: clsx(className, {
      [classes.BreadcrumbsBase]: enabled
    }),
    "aria-label": "Breadcrumbs",
    sx: sxProp
  }, /*#__PURE__*/React.createElement(BreadcrumbsList, null, wrappedChildren));
}
Breadcrumbs.displayName = "Breadcrumbs";
const StyledBreadcrumbsItem = toggleStyledComponent(CSS_MODULES_FLAG, 'a', styled.a.withConfig({
  displayName: "Breadcrumbs__StyledBreadcrumbsItem",
  componentId: "sc-9m4wsf-2"
})(["color:", ";display:inline-block;font-size:", ";text-decoration:none;&:hover,&:focus{text-decoration:underline;}&.selected{color:", ";pointer-events:none;}&.selected:focus{text-decoration:none;}", ";"], get('colors.accent.fg'), get('fontSizes.1'), get('colors.fg.default'), sx));
const BreadcrumbsItem = /*#__PURE__*/React.forwardRef(({
  selected,
  className,
  ...rest
}, ref) => {
  const enabled = useFeatureFlag(CSS_MODULES_FLAG);
  return /*#__PURE__*/React.createElement(StyledBreadcrumbsItem, _extends({
    className: clsx(className, {
      [SELECTED_CLASS]: selected,
      [classes.Item]: enabled,
      [classes.ItemSelected]: enabled && selected
    }),
    "aria-current": selected ? 'page' : null,
    ref: ref
  }, rest));
});
Breadcrumbs.displayName = 'Breadcrumbs';
BreadcrumbsItem.displayName = 'Breadcrumbs.Item';
var Breadcrumbs$1 = Object.assign(Breadcrumbs, {
  Item: BreadcrumbsItem
});

/**
 * @deprecated Use the `Breadcrumbs` component instead (i.e. `<Breadcrumb>` → `<Breadcrumbs>`)
 */
const Breadcrumb = Object.assign(Breadcrumbs, {
  Item: BreadcrumbsItem
});

/**
 * @deprecated Use the `BreadcrumbsProps` type instead
 */

/**
 * @deprecated Use the `BreadcrumbsItemProps` type instead
 */

export { Breadcrumb, Breadcrumbs$1 as default };
